/**
 * Load shared HTML components (header, footer, logo, demo modal)
 * This allows us to maintain a single source of truth for repeated elements
 */

async function loadComponent(elementId: string, componentPath: string): Promise<void> {
  const element = document.getElementById(elementId)
  if (!element) {
    console.warn(`Element with id "${elementId}" not found`)
    return
  }

  try {
    const response = await fetch(componentPath)
    if (!response.ok) {
      throw new Error(`Failed to load ${componentPath}: ${response.status}`)
    }
    const html = await response.text()
    element.innerHTML = html
  } catch (error) {
    console.error(`Error loading component ${componentPath}:`, error)
  }
}

export async function loadComponents(): Promise<void> {
  // Load header, footer, and demo modal first
  await Promise.all([
    loadComponent('header-placeholder', '/src/components/header.html'),
    loadComponent('footer-placeholder', '/src/components/footer.html'),
    loadComponent('demo-modal-placeholder', '/src/components/demo-modal.html')
  ])

  // Then load logos into header and footer
  await Promise.all([
    loadComponent('header-logo-placeholder', '/src/components/logo.html'),
    loadComponent('footer-logo-placeholder', '/src/components/logo.html')
  ])
}
